import styled from 'styled-components';
import Button from '../../../../core-components/Button/Button';

import Image from '@stencil/image';

export const TryAlternateDatesButton = styled(Button)(
  props => `
  width: 90%;
  margin: 0 auto;
  font-weight: bold;
  font-size: ${props.theme.font.custom(16)}
  text-transform: uppercase;
`,
);

export const SoldOutWrapperDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: column;
  width: 98%;
  background-color:${props.theme.colors.goRed.light};
  border-radius:${props.theme.misc.borderRadius.large};
  // margin-top:${props.theme.spacing.xlarge};

`,
);

export const IconWrapperSpan = styled.span(
  props => `
  margin: 0 ${props.theme.spacing.base} 0 0;
`,
);

export const SoldOutInnerDiv = styled.div(
  props => `
  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  padding: ${props.theme.spacing.xlarge} ${props.theme.spacing.base} ${props.theme.spacing.xlarge} ${props.theme.spacing.base};
`,
);

export const TimerImage = styled(Image)(
  props => `

    margin-right:${props.theme.spacing.base};
    width: 4.2rem;
    height: 4.2rem;

`,
);

export const SoldOutTextWrappDiv = styled.div(
  props => `
  display:flex;
  flex-wrap: wrap;
  flex-direction: column;
`,
);

export const FirstTxtPara = styled.p(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: column;
  color:${props.theme.colors.goRed.base};
  font-weight:bold;
  font-size:${props.theme.font.custom(16)};
  padding-bottom:${props.theme.spacing.xsmall};
  text-transform: uppercase;
`,
);

export const AlternateDateLink = styled.a(
  props => `
  display:inline-flex;
  cursor: pointer;
  padding-top:${props.theme.spacing.xsmall};

  color: ${props.theme.colors.goBrandBlue.base};
  &:hover{
    color: ${props.theme.colors.goBrandBlue.base};
  }
`,
);

export const SoldOutTriggerText = styled.div(
  props => `
  width: 100%;
  text-align: center;
  margin: 10px 0 0 0;
  text-transform: ${props.uppercase ? 'uppercase' : 'none'};
  color: ${props.theme.colors.goBrandBlue.base};
  font-size: ${props.theme.font.custom(14)};
  cursor: pointer;
`,
);

export const ActionTextsContainer = styled.div(
  props => `
  width: 100%;
  margin: ${props.theme.spacing.base} 0 0 0;
`,
);
